// @ts-nocheck
import CalendarLine from "@store/Library/Components/Toolkit/Icons/Calendar/CalendarLine";
import { buttonFieldIconClickableStyles, buttonFieldIconStyles } from "@store/Themes/common/mixins/button";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* Store Custom Code - Start */
import Close from "@store/Library/Components/Toolkit/Icons/Close";
/* Store Custom Code - End */

const datePicker: Styleguide["datePicker"] = {
    formatBasedOnLanguage: true,
    defaultProps: {
        format: "M/d/yyyy", // Date Time: "M/d/yyyy, hh:mm a"
        calendarIconProps: {
            src: CalendarLine,
            color: "inherit",
            css: buttonFieldIconStyles(),
        },
        clearIconProps: {
            src: Close /* Store Custom Code */,
            color: "inherit",
        },
        cssOverrides: {
            formField: null as any,
            datePicker: css`
                .react-datetime-picker {
                    &__calendar-button {
                        ${buttonFieldIconClickableStyles()}
                    }
                    /* Store Custom Code - Start */
                    &__inputGroup {
                        &:hover {
                            border-color: transparent !important;
                        }
                    }
                    /* Store Custom Code - End */
                }

                .react-calendar {
                    box-shadow: ${x => x.theme.shadows.e60};

                    button {
                        transition: ${transitionHoverStyles("color", "background-color")};
                    }
                }
            `,
        },
    },
};

export default datePicker;
